import component from './pt-BR/component';
import globalHeader from './pt-BR/globalHeader';
import menu from './pt-BR/menu';
import pages from './pt-BR/pages';
import pwa from './pt-BR/pwa';
import settingDrawer from './pt-BR/settingDrawer';
import settings from './pt-BR/settings';
import fixOverlay from './pt-BR/fix_overlay';
import fixOpenapi from './pt-BR/fix_openapi';
import fixAdminMisc from './pt-BR/fix_adminmisc';
import fixBilling from './pt-BR/fix_billing';
import fixComponents from './pt-BR/fix_components';
import fixConsoleMisc from './pt-BR/fix_consolemisc';
import fixGap from './pt-BR/fix_gap';
import fixSystemconfig from './pt-BR/fix_systemconfig';
import fixTenant from './pt-BR/fix_tenant';
import fixVoiceClone from './pt-BR/fix_voiceclone';
import fixTodo from './pt-BR/fix_todo';
import fixLedger from './pt-BR/fix_ledger';


export default {
  'navBar.lang': 'Idioma',
  'layout.user.link.help': 'Ajuda',
  'layout.user.link.privacy': 'Privacidade',
  'layout.user.link.terms': 'Termos',
  'app.preview.down.block': 'Baixar esta p��gina para o projeto local',
  'app.welcome.link.fetch-blocks': 'Obter todos os blocos',
  'app.welcome.link.block-list': 'Crie p��ginas padr?o rapidamente usando o framework de desenvolvimento de blocos',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
